// ======================================================================
// 📁 drawer-planning.api.js
// PURPOSE:
//   All PPE Planning Drawer backend communication
// ======================================================================

import axiosClient from "../../../../api/axiosClient";

// ------------------------------------------------------------
// LOAD PLANNING CONTEXT
// ------------------------------------------------------------
export const getPlanningContext = (orderItemId) =>
  axiosClient.get(
    `/api/ppe/planning/order-items/${orderItemId}/prepare`
  );

// ------------------------------------------------------------
// SAVE DRAFT
// ------------------------------------------------------------
export const savePlanningDraft = (payload) =>
  axiosClient.post(
    "/api/ppe/planning/drafts",
    payload
  );

// ------------------------------------------------------------
// VALIDATE DRAFT
// ------------------------------------------------------------
export const validatePlanningDraft = (draftId) =>
  axiosClient.post(
    `/api/ppe/planning/drafts/${draftId}/validate`
  );

  // ------------------------------------------------------------
// ✅ LOAD WORKING AREA MASTER
// ------------------------------------------------------------
export const getWorkingAreas = () =>
  axiosClient.get("/api/ppe/planning/working-areas");

// ------------------------------------------------------------
// APPLY VALIDATED SCHEDULE (SAVE ACCEPTED DATES)
// ------------------------------------------------------------
export const applyValidatedScheduleToDraft = (
  draftId,
  acceptedOperations
) =>
  axiosClient.post(
    `/api/ppe/planning/drafts/${draftId}/apply-validated-schedule`,
    {
      accepted_operations: acceptedOperations,
    }
  );
// ============================================================
// SUBMIT PRODUCTION PLAN FOR APPROVAL
// Timestamp: 2026-01-25
// ============================================================

export const submitPlanForApproval = (draftId) => {
  return axiosClient.post(
    "/api/ppe/planning/approvals/submit",
    {
      draft_id: draftId,
    }
  );
};
